import React, { useEffect, useState, useRef } from "react";
import {View} from "react-native";
import OpenGameNotification from "./OpenGameNotification";
import SimpleNotification from "./SimpleNotification";
import { useNavigation } from "@react-navigation/native";

const Notification = ({notification, onDismiss, timeoutSeconds}) => {
    useEffect(() => {
        const timeout = setTimeout(() => {
            onDismiss(false);
        }, typeof timeoutSeconds === "number" ? timeoutSeconds * 1000 : 3000);
        return () => clearTimeout(timeout);
    }, []);
    const navigation = useNavigation();


    let message = null;
    if (notification.type === "open-game-ready") {
        message = <SimpleNotification message={`Game #${notification.gameId} is ready to start.`} description={"Click here to go to the game."} timeout={10000} onDismissPress={() => {
            navigation.navigate('GameTable', { id: notification.gameAlphanumericId });
            onDismiss(true);
        }} />;
    } else if (notification.type === "player-turn") {
        message = <SimpleNotification message={`It's your turn in Game #${notification.gameId}!`} timeout={10000} onDismissPress={() => {
            navigation.navigate('GameTable', { id: notification.gameAlphanumericId });
            onDismiss(true);
        }} />;
    } else {
        message = <SimpleNotification message={notification.message} description={notification.description} timeout={10000} onDismissPress={() => onDismiss(true)} />;
    }

    return (
        <View style={{
            position: 'absolute',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            top: 32,
            left: 0,
            right: 0,
            margin: 20,
            zIndex: 10
        }}>
            {message}
        </View>
    );
};

export default Notification;